module.exports = __webpack_public_path__ + "img/lc.975a581d.svg";